const formDateTimePicker = {
  update: (field, appData) => {
    const value = appData.values[field.name];
    const isRequired = !field.params.includes("TDFieldOptionIsOptional");
    const isValid = !!(value || !isRequired);
    const fieldObject = {
      fieldName: field.name,
      isValid,
      isRequired,
      errorMessage: !isValid
        ? `${field.title} ${appData.settings.translations.field_missing}`
        : null,
      value,
      title: field.title
    };
    const fieldsArray = appData.screenValidation.fields;
    const index = fieldsArray.findIndex(
      fieldItem => fieldItem.fieldName === field.name
    );
    if (index > -1) {
      fieldsArray[index] = fieldObject;
    } else {
      fieldsArray.push(fieldObject);
    }
    return fieldObject;
  }
};

export default formDateTimePicker;
